import * as Yup from 'yup';
import { SponsorTypeCodes } from '@Enum/api/SponsorTypeCodes.enum';
import dayjs from 'dayjs';

export const OverseasMissionFormSchema = Yup.object().shape({
  employeeNumber: Yup.string().required(
    'Please fill proper empoyee number and click search'
  ),
  employeeName: Yup.string().required(
    'Please find user by employee number search'
  ),
  placeOfTravel: Yup.string().required('Please fill place of travel'),
  dateOfTravel: Yup.string().required('Please choose date of travel'),
  returnDate: Yup.string()
    .required('Please choose return date')
    .test(
      'Validate chosen date not less than dateOfTravel',
      'Return day should be NOT less than date of travel day!',
      (date, context) => {
        const { dateOfTravel } = context.parent;

        if (!dateOfTravel) {
          return true;
        }

        const chosenDateLessThanDateOfTravel =
          dayjs(date).startOf('day') < dayjs(dateOfTravel).startOf('day');
        return !chosenDateLessThanDateOfTravel;
      }
    ),
  totDays: Yup.string(),
  purposeOfTravel: Yup.string().required('Please fill purpose of travel'),
  approvedTravelAmount: Yup.number()
    .nullable()
    .required('Please fill approved travel amount'),
  designation: Yup.string().nullable(),
  currentLocation: Yup.string().nullable(),
  country: Yup.string().required('Please choose country'),
  sponsoredBy: Yup.string().required('Please choose sponsor'),
  sponsoredByExtra: Yup.string()
    .test(
      'Validation for case when Company is chosen in sponsorBy',
      'Please choose company',
      (value, context) => {
        if (context.parent.sponsoredBy === String(SponsorTypeCodes.COMPANY)) {
          return !!value;
        }

        return true;
      }
    )
    .test(
      'Validation for case when Supplier is chosen in sponsorBy',
      'Please describe supplier',
      (value, context) => {
        if (context.parent.sponsoredBy === String(SponsorTypeCodes.SUPPLIER)) {
          return !!value;
        }

        return true;
      }
    ),
});
